import moment from 'moment';

moment.fn.toJSON = function() {
  const JSONmoment = this.format('MM/DD/YYYY');
  return JSONmoment;
};
